import { createSelector } from 'reselect';
import { sortBy, last } from 'lodash';

import selectCustomWebStylesObj from './selectCustomWebStylesObj';

const selectCustomWebStylesLast = createSelector(selectCustomWebStylesObj, (obj) => {
  const urlParams = new URLSearchParams(window.location.search);
  const customWebStylesId = urlParams.get('customWebStylesId');
  if (customWebStylesId) {
    return obj[customWebStylesId];
  }
  const array = sortBy(obj, 'createdAt').filter((el) => el.published && (el.scope === 'patientForm' || !el.scope));
  return last(array);
});

export default selectCustomWebStylesLast;
